<template>
    <nav class="menu-container">
     <h3> <!-- <font color="#00AB39">E3路</font>-->公交站点</h3> 
      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
    </nav>
  </template>
  
  <script>
  import Icon from "@/components/Icon";
  export default {
    components: {
      Icon,
    },
    data() {
      return {
        items: [
          // 模板         {
          //  name: "azhan",
          //  title: "A站",
          //  icon: "chat",
          //  exact: true,
          //  },
  
          {
            name: "zhishengjichang",
             title: "直升机场",
            // icon: "chat",
            exact: true,
          },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
          // {
          //   name: "",
          //    title: "",
          //   // icon: "chat",
          //   exact: true,
          // },
        ],
      };
    },
  };
  </script>
  
  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(67, 47, 221);
      }
    }
  }
  </style>
  
  
  
  
  
  